// Equipment Category enum matching backend
export enum EquipmentCategory {
  LargeApparatus = 1,  // Reformer, Cadillac, Chair
  SmallApparatus = 2,  // Spine Corrector, Arc Barrel
  Props = 3,           // Magic Circle, Theraband, Balls
  Mat = 4              // Mat work
}

// Helper function to get category display names
export const getEquipmentCategoryName = (category: EquipmentCategory): string => {
  switch (category) {
    case EquipmentCategory.LargeApparatus:
      return 'Large Apparatus';
    case EquipmentCategory.SmallApparatus:
      return 'Small Apparatus';
    case EquipmentCategory.Props:
      return 'Props';
    case EquipmentCategory.Mat:
      return 'Mat';
    default:
      return 'Unknown';
  }
};

// API Request/Response Types
export interface CreatePlatformEquipmentRequest {
  name: string;
  description?: string;
  category: EquipmentCategory;
  requiresSetup: boolean;
  displayOrder: number;
  iconName?: string;
}

export interface UpdatePlatformEquipmentRequest {
  name?: string;
  description?: string;
  category: EquipmentCategory;
  requiresSetup: boolean;
  displayOrder: number;
  iconName?: string;
  isActive: boolean;
}

export interface PlatformEquipmentSummaryResponse {
  id: number;
  name: string;
  description?: string;
  category: EquipmentCategory;
  requiresSetup: boolean;
  isActive: boolean;
  iconName?: string;
  displayOrder: number;
  createdAt: string;
  updatedAt?: string;
}

export interface PlatformEquipmentDetailResponse {
  id: number;
  name: string;
  description?: string;
  category: EquipmentCategory;
  requiresSetup: boolean;
  displayOrder: number;
  isActive: boolean;
  iconName?: string;
  isPlatformEquipment: boolean;
  createdAt: string;
  updatedAt?: string;
}

// Paginated API response
export interface PlatformEquipmentListResponse {
  equipment: PlatformEquipmentSummaryResponse[];
  pagination: {
    page: number;
    pageSize: number;
    totalCount: number;
    totalPages: number;
  };
}

// Form data type for the equipment form
export interface EquipmentFormData {
  name: string;
  description: string;
  category: EquipmentCategory;
  requiresSetup: boolean;
  displayOrder: number;
  iconName: string;
  isActive?: boolean;
}